import { defineStore } from "pinia";

export const useDashboardEventsStore = defineStore("dashboardEvents", {
  state: () => {
    return {
      events: [] as { time: string; type: string; event: string; spaceId: number }[],
    };
  },
  actions: {
    removeEvent() {
      this.events.pop();
    },
    addEvent(event: { time: string; type: string; event: string; spaceId: number }) {
      this.events.unshift(event);
    },
    clearEvents() {
      this.events = [];
    },
  }
});
